<template>
  <div class="flex">
    <SideBar />
    <div
      v-if="pollData == null"
      class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
      style="box-shadow: 0px 2px 30px 0px #01b0f926"
    >
      <div class="p-4 sm:p-6 lg:p-10 flex flex-col gap-8">
        <div class="flex flex-col gap-6">
          <div class="flex justify-between items-center">
            <h2 class="text-lg sm:text-xl font-bold text-primary">
              Lessons Poll
            </h2>
            <div
              v-if="pollList.length > 0"
              @click="polldownload()"
              class="bg-blues w-full md:w-auto justify-center text-white rounded-2xl py-1.5 px-5 flex items-center gap-2 cursor-pointer"
            >
              <img src="@/assets/newd/download1.png" alt="" />
              <p class="text-sm text-white">Download</p>
            </div>
          </div>
          <div
            class="w-full bg-[#edf8ff] flex justify-center gap-5 items-center px-2 py-2 lg:px-8 rounded-md"
            v-if="response_message"
          >
            <h2 class="text-blues text-center">
              {{ response_message }}
            </h2>

            <router-link
              :to="{ name: 'DownloadHistory' }"
              class="text-blue-600 text-xs underline font-bold"
            >
              Download History
            </router-link>
          </div>
          <div v-if="loading" class="text-center py-10">
            <div class="flex justify-center items-center">
              <img src="@/assets/newd/loading.gif" alt="" class="h-10" />
            </div>
          </div>

          <div v-else>
            <div
              class="flex flex-col gap-4"
              v-if="!loading && this.pollList.length > 0"
            >
              <div
                v-for="poll in pollList"
                :key="poll"
                @click="getDataofPoll(poll.lesson.id)"
                class="bg-blues flex items-center justify-between gap-5 rounded-2xl px-5 sm:px-10 py-2 cursor-pointer"
              >
                <p class="font-bold text-sm text-white">
                  {{ poll.lesson.title }}
                </p>
                <div @click.stop="singledownload(poll.lesson.id)">
                  <img src="@/assets/newd/download1.png" alt="" />
                </div>
              </div>
            </div>
            <p v-else>No Lesson Polls</p>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="pollData != null"
      class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
      style="box-shadow: 0px 2px 30px 0px #01b0f926"
    >
      <div class="p-4 sm:p-6 lg:p-10 flex flex-col gap-6 sm:gap-8">
        <div class="flex items-center justify-between">
          <h1 class="text-base sm:text-lg md:text-xl font-bold">
            Question: {{ pollData.question }}
          </h1>
          <div>
            <button
              class="bg-blues text-white hover:bg-blue-600 rounded-xl px-4 py-1 text-xs sm:text-sm"
              @click="
                pollData = null;
                student_list = [];
                currentIndex = null;
              "
            >
              Back
            </button>
          </div>
        </div>

        <div
          class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-4 gap-4"
        >
          <div
            v-for="(option, index) in pollData.options"
            :key="option"
            class="bg-gray-200 rounded-2xl px-5 py-3 flex flex-col gap-2 cursor-pointer"
            @click="getStudentofPoll(option.student_list, index)"
          >
            <p class="font-bold text-sm text-black">Option: {{ index + 1 }}</p>
            <p class="font-bold text-sm text-black">{{ option.text }}</p>
            <p class="text-sm">
              Student Answered Count: {{ option.student_list.length }}
            </p>

            <div class="flex items-center justify-center flex-col">
              <button
                class="bg-blues text-white mt-2 px-4 py-2 rounded-lg text-xs sm:text-sm w-auto"
              >
                View Answered Students
              </button>
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-5" v-if="currentIndex !== null">
          <h2 class="font-bold text-sm">
            Option: {{ currentIndex + 1 }} (View Answered Students)
          </h2>

          <div
            v-for="(student, index) in student_list"
            :key="index"
            class="flex flex-col ga-3 my-3"
          >
            <div
              class="bg-gray-200 flex flex-col rounded-xl px-5 py-2 gap-2 cursor-pointer text-sm"
            >
              <p v-if="student.name">
                <span class="font-bold">Name:</span> {{ student.name }}
              </p>
              <p v-if="student.remark">
                <span class="font-bold">Submitted Remark:</span>
                {{ student.remark }}
              </p>
            </div>
          </div>

          <p v-if="student_list.length === 0">No student answered</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SideBar from "@/components/Instructor/SideBar.vue";

import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: {
    SideBar,
  },
  data() {
    return {
      pollList: [],
      pollData: null,
      student_list: [],
      currentIndex: null,
      response_message: "",
      loading: false,
    };
  },

  props: ["course_id"],

  async created() {
    this.detailsgets();
  },

  mounted() {},

  computed: {
    ...mapGetters(["userInfo"]),
  },

  methods: {
    getStudentofPoll(list, index) {
      this.student_list = [];
      this.student_list = list;
      this.currentIndex = index;
    },

    async getDataofPoll(id) {
      await axios
        .get(
          `${process.env.VUE_APP_API}/poll/list/?lesson__course_name__id=${this.course_id}&Key=${this.userInfo.token_key}&lesson__id=${id}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.pollData = response.data.data[0];
          } else {
            console.log("No data found.");
          }
        });
    },

    // courseSectionToggle(id) {
    //   if (this.activeCourseMenu == id) {
    //     this.activeCourseMenu = null;
    //   } else {
    //     this.activeCourseMenu = id;
    //   }
    // },

    // setActiveSection() {
    //   const activeSection =
    //     this.lessonInfo.results[this.activeIndex].section_id;
    //   this.activeCourseMenu = activeSection;
    // },
    async detailsgets() {
      this.loading = true;
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/poll/list/?lesson__course_name__id=${this.course_id}&Key=${this.userInfo.token_key}`
        );

        if (response.data.status == 200) {
          this.pollList = response.data.data;
        }
      } catch (e) {
        console.log("Error:", e);
      } finally {
        this.loading = false;
      }
    },
    async polldownload() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/polls/csv/generate/${this.course_id}/?Key=${this.userInfo.token_key}`
        )
        .then((resp) => {
          if (resp) {
            this.response_message =
              "Your file is ready to download go to download history page";

            setTimeout(() => {
              this.response_message = "";
            }, 5000);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    async singledownload(id) {
      try {
        const resp = await axios.get(
          `${process.env.VUE_APP_API}/polls/download/?course_id=${this.course_id}&lesson_id=${id}&Key=${this.userInfo.token_key}`
        );

        if (resp && resp.data.status == 200 && resp.data.download_link) {
          const link = document.createElement("a");
          link.href = resp.data.download_link;
          link.download = "";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      } catch (err) {
        console.error("Download error:", err);
      }
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}

:deep(.video-container iframe) {
  width: 100% !important;
  height: auto !important;
  aspect-ratio: 16 / 9;
  max-height: 500px;
}
</style>
